/* ═══════════════════════════════════════════════════════════════
   Paddle Palace — Collection Comparison Chart  (v11)

   SORTED THUMBNAIL:
   • Clones real product card HTML from #product-grid (and from
     fetched section pages). Identical appearance — same classes,
     same --aspect-ratio, same badges, hover effects, everything.
   • Reuses the exact grid classes/style from the live DOM.

   SORT CHANGES:
   • Numeric columns (speed/spin/control etc): first click = DESC
     (highest first). Second click = ASC.
   • Text columns: first click = ASC (A→Z). Second click = DESC.
   • Empty / "x" / "n/a" / non-numeric always sorted to bottom,
     regardless of direction.
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var HANDLES    = ['rubber', 'shakehand-blades', 'penhold-blades'];
  var pathHandle = window.location.pathname.replace(/\/$/, '').split('/').pop();
  if (HANDLES.indexOf(pathHandle) === -1) return;

  var isRubber  = (pathHandle === 'rubber');
  var STORE_KEY = 'pp_coll_view_' + pathHandle;
  var PAGE_KEY  = 'pp_coll_page_' + pathHandle;
  var PAGE_SIZE  = 25;   /* products added per Load More click */
  var visibleCount = PAGE_SIZE; /* grows with each Load More */
  var NUMERIC   = ['speed','spin','control','weight','blade_thickness','price'];
  var MAX_PAGES = 15;

  /* ── Dynamic lookups ─────────────────────────────────────────── */
  function $section()   { return document.querySelector('.sec__collection-main'); }
  function $gridBox()   { return document.getElementById('productgridcontainer'); }
  function $chartWrap() { return document.getElementById('pp-chart-wrap'); }
  function $dataEl()    { return document.getElementById('pp-product-data'); }
  function $thumbGrid() { return document.getElementById('pp-thumb-grid'); }
  function $realGrid()  { return document.getElementById('product-grid'); }

  /* ── Preferences ─────────────────────────────────────────────── */
  /* View always defaults to thumbnail on fresh page load (no persistence) */
  var currentView = 'thumb';
  function savedView() { return currentView; }
  function saveView(v) { currentView = v; }
  function savedPage() { try { return parseInt(localStorage.getItem(PAGE_KEY),10)||0; } catch(e){ return 0; } }
  function savePage(p) { try { localStorage.setItem(PAGE_KEY,p); } catch(e){} }

  function filtersActive() { return window.location.search.indexOf('filter.')!==-1; }
  function getSectionId() {
    var s=$section(); return s?(s.dataset.sectionId||s.getAttribute('data-section-id')||''):'';
  }

  /* ── Product data store ──────────────────────────────────────── */
  var productStore = {}, productOrder = [];

  function resetStore() { productStore={}; productOrder=[]; cardHtmlStore={}; }

  function storeProducts(list) {
    list.forEach(function(p) {
      if (!productStore[p.handle]) {
        productStore[p.handle]=p;
      } else if (p.speed!==''&&p.speed!==undefined&&p.speed!==null) {
        /* Merge: keep existing data, overlay with new if it has metafields */
        var existing = productStore[p.handle];
        Object.keys(p).forEach(function(k) {
          if (p[k]!==''&&p[k]!==null&&p[k]!==undefined) existing[k]=p[k];
        });
      }
      if (productOrder.indexOf(p.handle)===-1) productOrder.push(p.handle);
    });
  }

  /* ── Card HTML store (cloned from real DOM) ──────────────────── */
  var cardHtmlStore = {}; /* handle → outerHTML of real product card */

  function handleFromCard(card) {
    var link=card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var parts=link.getAttribute('href').split('/products/');
    return parts.length>1 ? parts[1].split('?')[0].split('#')[0] : '';
  }

  function extractCards(gridEl) {
    if (!gridEl) return;
    Array.prototype.slice.call(gridEl.children).forEach(function(card) {
      var h=handleFromCard(card);
      if (h && !cardHtmlStore[h]) cardHtmlStore[h]=card.outerHTML;
    });
  }

  /* ── JSON helpers ────────────────────────────────────────────── */
  function parseJsonBlock(doc) {
    var el=doc?doc.getElementById('pp-product-data'):$dataEl();
    if (!el) return [];
    try { return JSON.parse(el.textContent||el.innerHTML)||[]; } catch(e){ return []; }
  }

  /* ── Parallel section-page fetches ──────────────────────────── */
  function fetchAllPagesParallel(sectionId, extraParams) {
    if (!sectionId) return;
    var base=window.location.pathname+'?section_id='+sectionId;
    if (extraParams) base+='&'+extraParams;
    var promises=[];
    for (var p=2; p<=MAX_PAGES; p++) {
      (function(pageNum){
        promises.push(
          fetch(base+'&page='+pageNum)
            .then(function(r){ return r.text(); })
            .then(function(html){
              var doc=new DOMParser().parseFromString(html,'text/html');
              var products=parseJsonBlock(doc);
              if (products.length) {
                storeProducts(products);
                extractCards(doc.getElementById('product-grid')); /* store card HTML */
                if (savedView()==='chart'&&$chartWrap()) renderChart();
              }
              return products.length;
            })
            .catch(function(){ return 0; })
        );
      })(p);
    }
    Promise.all(promises).then(function(){ applyView(savedView(),false); });
  }

  function loadAllProducts() {
    resetStore();
    storeProducts(parseJsonBlock(null));
    extractCards($realGrid()); /* store initial page's card HTML */
    fetchAllPagesParallel(getSectionId(), window.location.search.replace(/^\?/,''));
  }

  function getDisplayProducts() {
    return productOrder.map(function(h){ return productStore[h]; }).filter(Boolean);
  }

  /* ── Sort ────────────────────────────────────────────────────── */
  var sortCol=null, sortDir='asc';

  function numericVal(v) {
    /* Empty / x / n/a → treat as -Infinity so they always sort last */
    if (v===''||v===null||v===undefined) return null;
    var s=String(v).trim().toLowerCase();
    if (s===''||s==='x'||s==='n/a'||s==='-') return null;
    var n=parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function sortProducts(arr) {
    if (!sortCol) return arr;
    var isNum=NUMERIC.indexOf(sortCol)!==-1;
    return arr.slice().sort(function(a,b){
      var va=a[sortCol]!==undefined?a[sortCol]:'';
      var vb=b[sortCol]!==undefined?b[sortCol]:'';
      if (isNum) {
        var na=numericVal(va), nb=numericVal(vb);
        if (na===null&&nb===null) return 0;
        if (na===null) return 1;   /* blanks always last */
        if (nb===null) return -1;
        return sortDir==='asc' ? na-nb : nb-na;
      }
      va=String(va).toLowerCase(); vb=String(vb).toLowerCase();
      return sortDir==='asc'?va.localeCompare(vb):vb.localeCompare(va);
    });
  }

  /* ── Columns ─────────────────────────────────────────────────── */
  var RUBBER_COLS=[
    {key:'img',         label:'',            cls:'pp-th-img'},
    {key:'title',       label:'Name',        cls:'sortable'},
    {key:'vendor',      label:'Brand',       cls:'sortable'},
    {key:'rubber_type', label:'Rubber Type', cls:'sortable'},
    {key:'speed',       label:'Speed',       cls:'sortable pp-th-stat'},
    {key:'spin',        label:'Spin',        cls:'sortable pp-th-stat'},
    {key:'control',     label:'Control',     cls:'sortable pp-th-stat'},
    {key:'hardness',    label:'Hardness',    cls:'sortable'},
    {key:'rubber_tech', label:'Rubber Tech', cls:'sortable'},
    {key:'price',       label:'Price',       cls:'sortable pp-th-price'}
  ];
  var SHAKEHAND_COLS=[
    {key:'img',             label:'',        cls:'pp-th-img'},
    {key:'title',           label:'Name',    cls:'sortable'},
    {key:'vendor',          label:'Brand',   cls:'sortable'},
    {key:'class',           label:'Class',   cls:'sortable'},
    {key:'speed',           label:'Speed',   cls:'sortable pp-th-stat'},
    {key:'control',         label:'Control', cls:'sortable pp-th-stat'},
    {key:'ply',             label:'Ply',     cls:'sortable'},
    {key:'weight',          label:'Wt (g)',  cls:'sortable'},
    {key:'blade_thickness', label:'Thickness', cls:'sortable'},
    {key:'price',           label:'Price',   cls:'sortable pp-th-price'}
  ];
  var PENHOLD_COLS=[
    {key:'img',             label:'',            cls:'pp-th-img'},
    {key:'title',           label:'Name',        cls:'sortable'},
    {key:'vendor',          label:'Brand',       cls:'sortable'},
    {key:'class',           label:'Class',       cls:'sortable'},
    {key:'blade_type',      label:'Blade Type',  cls:'sortable'},
    {key:'speed',           label:'Speed',       cls:'sortable pp-th-stat'},
    {key:'control',         label:'Control',     cls:'sortable pp-th-stat'},
    {key:'ply',             label:'Ply',         cls:'sortable'},
    {key:'weight',          label:'Wt (g)',      cls:'sortable'},
    {key:'blade_thickness', label:'Thickness',   cls:'sortable'},
    {key:'price',           label:'Price',       cls:'sortable pp-th-price'}
  ];

  /* ── Helpers ─────────────────────────────────────────────────── */
  function money(c){return '$'+(c/100).toFixed(2);}
  function esc(s){
    return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function statBar(val,type){
    var n=numericVal(val); if(n===null) return '';
    var cls='pp-fill pp-fill-'+(type||'control');
    return '<div class="pp-stat-row"><div class="pp-track"><div class="'+cls+'" style="--v:'+n+'"></div></div>'
      +'<span class="pp-num">'+esc(String(val))+'</span></div>';
  }

  /* ── Render comparison chart ─────────────────────────────────── */
  function renderChart(pageOverride) {
    var wrap=$chartWrap(); if(!wrap) return;
    var products=sortProducts(getDisplayProducts());
    var total=products.length;
    /* Load More: show up to visibleCount products */
    var end=Math.min(visibleCount, total), rows=products.slice(0, end);
    var cols=isRubber?RUBBER_COLS:(pathHandle==='penhold-blades'?PENHOLD_COLS:SHAKEHAND_COLS);

    var html='<table class="pp-chart-table" id="pp-chart-table"><thead><tr>';
    cols.forEach(function(c){
      if(c.key==='img'){html+='<th class="'+c.cls+'"></th>';}
      else{
        var active=(sortCol===c.key);
        var arrow=c.cls.indexOf('sortable')!==-1
          ?' <span class="pp-arr">'+(active?(sortDir==='asc'?'↑':'↓'):'↕')+'</span>':'';
        html+='<th class="'+c.cls+(active?' pp-sort-'+sortDir:'')+'" data-col="'+c.key+'">'+c.label+arrow+'</th>';
      }
    });
    html+='</tr></thead><tbody>';
    if(!rows.length){
      html+='<tr><td colspan="'+cols.length+'" class="pp-empty-cell">No products match.</td></tr>';
    } else {
      rows.forEach(function(p){
        var imgH=p.img?'<img src="'+esc(p.img)+'" alt="" loading="lazy">':'<span class="pp-no-img"></span>';
        html+='<tr>';
        cols.forEach(function(c){
          switch(c.key){
            case 'img':   html+='<td class="pp-td-img"><a href="'+esc(p.url)+'">'+imgH+'</a></td>'; break;
            case 'title': html+='<td><a href="'+esc(p.url)+'" class="pp-prod-link">'+esc(p.title)+'</a></td>'; break;
            case 'price':
              var priceHtml=money(p.price);
              if(p.sale&&p.compare_at_price>p.price) priceHtml='<span class="pp-sale-price">'+money(p.price)+'</span> <s class="pp-compare-price">'+money(p.compare_at_price)+'</s>';
              html+='<td class="pp-price-cell'+(p.sale?' pp-sale-item':'')+'">'+priceHtml+'</td>'; break;
            case 'speed': case 'spin': case 'control':
              html+='<td class="pp-stat-cell">'+statBar(p[c.key],c.key)+'</td>'; break;
            default: html+='<td>'+esc(String(p[c.key]||''))+'</td>';
          }
        });
        html+='</tr>';
      });
    }
    html+='</tbody></table>';
    /* Load More — matches site's pagination-loadmore structure */
    if(total>0){
      var percent=Math.round(end/total*100);
      html+='<div class="pp-loadmore-wrap text-center">';
      html+='<div class="load-more-bar">';
      html+='<span class="loadmore-amount pp-pg-info">Showing '+end+' of '+total+' products</span>';
      html+='<div class="load-more-bar-percent w-custom max-w-100 mx-auto h-2 border-bg btn-rounded relative mt-10" style="--custom-width:30rem">';
      html+='<span class="load-more-percent absolute inset-y-0 left-0 heading-bg inline-block btn-rounded transition" style="width:'+percent+'%"></span>';
      html+='</div></div>';
      if(end<total){
        html+='<button class="pp-load-more inline-flex mt-30 relative no-underline btn-primary">Load More</button>';
      }
      html+='</div>';
    }
    wrap.innerHTML=html;
    var tbl=wrap.querySelector('#pp-chart-table');
    if(tbl) tbl.querySelectorAll('thead th[data-col]').forEach(function(th){
      th.addEventListener('click',function(){
        var col=th.getAttribute('data-col');
        if(sortCol===col) { sortDir=(sortDir==='asc'?'desc':'asc'); }
        else { sortDir=NUMERIC.indexOf(col)!==-1?'desc':'asc'; sortCol=col; }
        renderChart(0);
      });
    });
    var loadMoreBtn=wrap.querySelector('button.pp-load-more');
    if(loadMoreBtn) loadMoreBtn.addEventListener('click',function(){
      visibleCount+=PAGE_SIZE;
      renderChart();
      /* Scroll to show newly loaded rows */
      var newRows=wrap.querySelectorAll('tbody tr');
      if(newRows[end]) newRows[end].scrollIntoView({behavior:'smooth',block:'nearest'});
    });
  }

  /* ── Render sorted thumbnail grid using REAL card HTML ───────── */
  function renderThumbGrid() {
    var container=$thumbGrid();
    if (!container) {
      container=document.createElement('div');
      container.id='pp-thumb-grid';
      var wrap=$chartWrap();
      if (wrap&&wrap.parentNode) wrap.parentNode.insertBefore(container,wrap.nextSibling);
    }

    /* Copy grid classes & style from the live product grid */
    var realGrid=$realGrid();
    var gridClass=realGrid?realGrid.className:'grid grid-cols row-gap-custom product-grid grid-columns-4 gap container-products-switch loadmore-lists';
    var gridStyle=realGrid?realGrid.getAttribute('style'):'';

    var products=sortProducts(getDisplayProducts());
    var colLabel=sortCol||'';
    var dirLabel=sortDir==='desc'?'High → Low':'Low → High';

    var sortLabelHtml='<div class="pp-thumb-sort-label">'
      +'Sorted by: <strong>'+esc(colLabel)+'</strong> ('+dirLabel+')'
      +' <button class="pp-clear-sort" id="pp-clear-sort">✕ Clear sort</button>'
      +'</div>';

    /* Build cards — use real HTML where available, fallback otherwise */
    var cardsHtml='';
    products.forEach(function(p){
      if (cardHtmlStore[p.handle]) {
        cardsHtml+=cardHtmlStore[p.handle];
      } else {
        /* Minimal fallback for products whose card HTML isn't fetched yet */
        var img=p.img?'<img src="'+esc(p.img.replace(/width=\d+/,'width=400').replace(/_\d+x\d+/,'_400x400'))+'" alt="'+esc(p.title)+'" loading="lazy" style="width:100%;display:block">':'';
        cardsHtml+='<div class="product-item product__item-js">'
          +'<div class="product-item__wrapper color-default product-grid">'
          +'<div class="product-item__inner hover-effect overflow-hidden relative">'
          +'<a href="'+esc(p.url)+'" class="block hover-effect" style="--aspect-ratio:1">'+img+'</a>'
          +'</div>'
          +'<div class="product-item__info mt-10">'
          +'<a href="'+esc(p.url)+'" class="product-item__name no-underline heading-color">'+esc(p.title)+'</a>'
          +'<div class="product-item__price">'+money(p.price)+'</div>'
          +'</div></div></div>';
      }
    });

    container.innerHTML=sortLabelHtml
      +'<div id="pp-sorted-grid" class="'+gridClass+'"'
      +(gridStyle?' style="'+gridStyle+'"':'')+'>'
      +cardsHtml+'</div>';

    var clearBtn=container.querySelector('#pp-clear-sort');
    if (clearBtn) clearBtn.addEventListener('click',function(){
      sortCol=null; sortDir='asc'; applyView('thumb',false);
    });
  }

  /* ── Apply view ───────────────────────────────────────────────── */
  function applyView(view, saveIt) {
    var section=$section(), isChart=(view==='chart'), isSorted=(!isChart&&sortCol!==null);
    if (section) {
      section.classList.toggle('pp-chart-mode',       isChart);
      section.classList.toggle('pp-sorted-thumb-mode', isSorted);
    }
    var btnT=document.getElementById('pp-btn-thumb'), btnC=document.getElementById('pp-btn-chart');
    if (btnT) btnT.classList.toggle('active',!isChart);
    if (btnC) btnC.classList.toggle('active', isChart);
    if (isChart)       renderChart();
    else if (isSorted) renderThumbGrid();
    if (saveIt!==false) saveView(view);
  }

  function reapply() {
    setTimeout(function(){ visibleCount=PAGE_SIZE; loadAllProducts(); applyView(savedView(),false); },80);
  }

  /* ── Event delegation ────────────────────────────────────────── */
  document.body.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('#pp-btn-thumb, #pp-btn-chart');
    if (!btn) return;
    savePage(0); applyView(btn.id==='pp-btn-chart'?'chart':'thumb',true);
  });

  /* ── MutationObservers ───────────────────────────────────────── */
  function watchSectionParent() {
    var s=$section(); if(!s||!s.parentNode) return;
    new MutationObserver(function(muts){
      var added=false;
      muts.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1)added=true;});});
      if(added) reapply();
    }).observe(s.parentNode,{childList:true});
  }
  function watchGridBox() {
    var b=$gridBox(); if(!b) return;
    new MutationObserver(reapply).observe(b,{childList:true});
  }

  /* ── Init ─────────────────────────────────────────────────────── */
  function init() { loadAllProducts(); applyView(savedView(),false); watchSectionParent(); watchGridBox(); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();

})();
